/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import {
  GetTransactionApiType,
  GetTransactionDetailApiType,
} from '../screens/Products/Edge/Transactions/typing';
import apiEndpoints from '../lib/apiEndpoints';
import apiCall from './apiCall';

export const getTransactionListApi = (data: GetTransactionApiType): any => {
  const { pageNo, limit, payload, sortBy, order, transactionType } = data;
  let endpoint = `${apiEndpoints.GET_EDGE_TRANSACTION_LIST}`;
  if (transactionType && transactionType === 'payment') endpoint = `${apiEndpoints.GET_EDGE_PAYMENT_TRANSACTION_LIST}`;
  else if (transactionType && transactionType === 'refund') endpoint = `${apiEndpoints.GET_EDGE_REFUND_TRANSACTION_LIST}`;
  return apiCall({
    method: 'get',
    endpoint: endpoint,
    query: {
      payload,
      pageNo,
      limit,
      ...(sortBy && order ? { sortBy, order } : {}),
    },
  });
};

export const getOrderListV3API = (data): any => {
  const requestPayload =
    data && typeof data === 'object' && 'payload' in data ? data.payload : data;
  const cancelKey =
    data && typeof data === 'object' ? data.cancelKey : undefined;
  return apiCall({
    method: 'get',
    endpoint: `${apiEndpoints.GET_EDGE_V3_ORDER_LIST}`,
    query: {
      payload: requestPayload,
    },
    cancelKey,
  });
};

export const getOrderLevelSummaryAPI = (data): any => {
  const { cancelKey, ...requestPayload } = data || {};
  return apiCall({
    method: 'post',
    endpoint: `${apiEndpoints.GET_ORDER_LEVEL_SUMMARY}`,
    payload: requestPayload,
    cancelKey,
  });
};

export const getSettlementDetailsAPI = (data: string | { orderId: string; cancelKey?: string }): any => {
  const orderId = typeof data === 'object' ? data.orderId : data;
  const cancelKey = typeof data === 'object' ? data.cancelKey : undefined;
  return apiCall({
    method: 'get',
    endpoint: `${apiEndpoints.GET_SETTLEMENT_DETAILS}/${orderId}`,
    cancelKey,
  });
};

export const getOrderDetailsAPI = (data: string | { orderId: string; cancelKey?: string }): any => {
  const orderId = typeof data === 'object' ? data.orderId : data;
  const cancelKey = typeof data === 'object' ? data.cancelKey : undefined;
  return apiCall({
    method: 'get',
    endpoint: `${apiEndpoints.GET_ORDER_DETAILS}/${orderId}`,
    cancelKey,
  });
};

export const getOrderRefundSettlementAPI = (data: string | { orderId: string; cancelKey?: string }): any => {
  const orderId = typeof data === 'object' ? data.orderId : data;
  const cancelKey = typeof data === 'object' ? data.cancelKey : undefined;
  return apiCall({
    method: 'get',
    endpoint: `${apiEndpoints.GET_ORDER_REFUND_SETTLEMENT}/${orderId}`,
    cancelKey,
  });
};

export const getOrderDetailsV3API = (
  data:
    | string
    | {
        orderId: string;
        merchantVersion: string;
        transactionDate: string;
        orderIdQuery: string;
        cancelKey?: string;
      },
  merchantVersionArg?: string,
  transactionDateArg?: string,
  orderIdQueryArg?: string
): any => {
  const requestData = typeof data === 'object' ? data : undefined;
  const orderId = requestData ? requestData.orderId : data;
  const merchantVersion = requestData
    ? requestData.merchantVersion
    : merchantVersionArg;
  const transactionDate = requestData
    ? requestData.transactionDate
    : transactionDateArg;
  const orderIdQuery = requestData ? requestData.orderIdQuery : orderIdQueryArg;
  const cancelKey = requestData ? requestData.cancelKey : undefined;
  return apiCall({
    method: 'get',
    endpoint: `${apiEndpoints.GET_EDGE_V3_ORDER_LIST}/${orderId}?merchantVersion=${merchantVersion}&transactionDate=${transactionDate}&orderIdQuery=${orderIdQuery}`,
    cancelKey,
  });
};

export const getTransactionFilterApi = (data?: { cancelKey?: string }): any => {
  return apiCall({
    method: 'get',
    endpoint: `${apiEndpoints.GET_EDGE_TRANSACTION_FILTERS}`,
    cancelKey: data?.cancelKey,
  });
};

export const getWalletNamesFilterApi = (data?: { cancelKey?: string }): any => {
  return apiCall({
    method: 'get',
    endpoint: `${apiEndpoints.GET_WALLET_NAME_FILTER}`,
    cancelKey: data?.cancelKey,
  });
};

export const getTransactionDetailApi = (
  data: GetTransactionDetailApiType
): any => {
  const { transactionId, cancelKey } = data as GetTransactionDetailApiType & {
    cancelKey?: string;
  };
  return apiCall({
    method: 'get',
    endpoint: `${apiEndpoints.GET_EDGE_TRANSACTION_DETAILS}/${transactionId}`,
    cancelKey,
  });
};

export const getOrderSummaryMetricsAPI = (data: {
  from_date: string;
  to_date: string;
  cancelKey?: string;
}): any => {
  const { cancelKey } = data;
  return apiCall({
    method: 'post',
    endpoint: apiEndpoints.GET_ORDER_SUMMARY_METRICS,
    payload: {
      filters: {
        from_date: data.from_date,
        to_date: data.to_date,
      },
    },
    cancelKey,
  });
};

export const pacbUploadInvoiceAPI = (data: {
  orderId: string;
  invoice_number: string;
  invoice_date: string;
}): any => {
  const { orderId, ...payload } = data;
  return apiCall({
    method: 'post',
    endpoint: `${apiEndpoints.PACB_UPLOAD_INVOICE}/${orderId}/upload`,
    payload,
  });
};

export const pacbGetInvoiceStatusAPI = (
  data: string | { orderId: string; cancelKey?: string }
): any => {
  const orderId = typeof data === 'object' ? data.orderId : data;
  const cancelKey = typeof data === 'object' ? data.cancelKey : undefined;
  return apiCall({
    method: 'get',
    endpoint: `${apiEndpoints.PACB_GET_INVOICE_STATUS}/${orderId}/invoiceStatus`,
    cancelKey,
  });
};

export const pacbDownloadInvoiceReceiptAPI = (orderId: string): any => {
  return apiCall({
    method: 'get',
    endpoint: `${apiEndpoints.PACB_GET_INVOICE_STATUS}/${orderId}/invoiceStatus`,
    query: { isDownload: true },
  });
};

export const pacbGetAwbStatusAPI = (
  data: string | { orderId: string; cancelKey?: string }
): any => {
  const orderId = typeof data === 'object' ? data.orderId : data;
  const cancelKey = typeof data === 'object' ? data.cancelKey : undefined;
  return apiCall({
    method: 'get',
    endpoint: `${apiEndpoints.PACB_GET_AWB_STATUS}/${orderId}/awbStatus`,
    cancelKey,
  });
};

export const pacbUploadAwbAPI = (data: {
  orderId: string;
  awbList: { awb_number: string; awb_date: string }[];
}): any => {
  return apiCall({
    method: 'post',
    endpoint: `${apiEndpoints.PACB_UPLOAD_AWB}/${data.orderId}/awb`,
    payload: data.awbList,
  });
};

export const pacbBulkUploadAPI = (file: File): any => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('job_type', 'invoice_upload');
  return apiCall({
    method: 'post',
    endpoint: apiEndpoints.PACB_BULK_UPLOAD,
    formData,
  });
};

// TODO: Update endpoint once download template API curl is provided
export const pacbDownloadBulkPaymentTemplateAPI = (): any => {
  return apiCall({
    method: 'get',
    endpoint: apiEndpoints.PACB_BULK_UPLOAD_TEMPLATE_DOWNLOAD,
    isDownloadCsv: true,
  });
};

export const pacbBulkUploadHistoryAPI = (payload: {
  from_date: string;
  to_date: string;
  page: number;
  size: number;
  sort_by?: string;
  order_by?: string;
  status?: string;
  type?: string;
  file_name?: string;
  cancelKey?: string;
}): any => {
  const { cancelKey, ...query } = payload;
  return apiCall({
    method: 'get',
    endpoint: apiEndpoints.PACB_BULK_UPLOAD_HISTORY,
    query,
    cancelKey,
  });
};

export const pacbBulkJobDownloadAPI = (jobId: string): any => {
  return apiCall({
    method: 'get',
    endpoint: `${apiEndpoints.PACB_BULK_UPLOAD}/${jobId}/download`,
    isDownloadCsv: true,
  });
};
